import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_SITE, LOCALHOST, getSite } from '../../constants/sites';

export const CurrentSite = createContext();

export const CurrentSiteProvider = ({ children }) => {
  const [currentSite, setCurrentSite] = useState(getSite());

  const site = getSite();

  useEffect(() => {
    setCurrentSite(site === LOCALHOST ? DEFAULT_SITE : site);
  }, [site]);

  return (
    <CurrentSite.Provider value={{ currentSite, setCurrentSite }}>
      {children}
    </CurrentSite.Provider>
  );
};

CurrentSiteProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useContextCurrentSite = () => useContext(CurrentSite);
